var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUpwardtrend(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.49381 4.97682C6.60419 5.08723 6.7539 5.14928 6.91002 5.14931H7.25499C7.41111 5.14928 7.56082 5.08723 7.6712 4.97682L10.4422 2.20585L11.7921 3.55572V0.0235596H8.25989L9.60976 1.37343L7.0825 3.90069L5.31642 2.13461C5.20605 2.0242 5.05634 1.96216 4.90022 1.96213H4.55524C4.39913 1.96216 4.24941 2.0242 4.13904 2.13461L0.190674 6.08298L1.02309 6.91539L4.72773 3.21074L6.49381 4.97682Z",
    fill: "#0D73D9"
  })));
}

export default SvgUpwardtrend;